import styled from "styled-components";

const DesktopNavigationStyle = styled.nav`
display: none;
  @media (min-width: 750px) {
    display: block;
  }
`;

export { DesktopNavigationStyle };